// @flow

// Libs
import React from 'react'
import _indexOf from 'lodash/indexOf'
import _map from 'lodash/map'
import _size from 'lodash/size'

// Components
import TableRow from './TableRow'
import TableCell from './TableCell'
import CellValue from './CellValue'

// Styles
import { bodyStyle } from './styles'

// Types
type Props<R: {id: number}> = {
  records: Array<R>,
  columns: Array<any>,
  renderer: { [string]: () => React.Element<any> },
  selectedRecords: Array<number>,
  onSelect: ?Function,
  smallScreen: boolean,
  rowStyle: Function | Object,
}

// Exports
export const TableBody = <R: { id: number }>({
  records,
  columns,
  renderer,
  onSelect,
  selectedRecords,
  smallScreen,
  rowStyle,
}: Props<R>): React.Element<any> => {
  //
  const rows = _map(records, function (record: R, index: number): React.Element<any> {
    const cells = _map(columns, function (column: Object, index2: number): React.Element<any> {
      const { attr, width, type } = column
      const align = type === 'number' ? 'right' : 'left'

      return (
        <TableCell key={`_cell_${index2}`} width={_size(columns) === 1 ? 100 : width} align={align}>
          <CellValue record={record} attr={attr} renderer={renderer} />
        </TableCell>
      )
    })

    return (
      <TableRow
        key={`_row_${index}`}
        odd={!!(index % 2)}
        record={record}
        onSelect={function (e: Event) {
          e.stopPropagation()
          if (onSelect != null) {
            onSelect(record.id)
          }
        }}
        selected={_indexOf(selectedRecords, record.id) >= 0}
        smallScreen={smallScreen}
        style={rowStyle}
      >
        {cells}
      </TableRow>
    )
  })

  return (
    <div data-test='TableBody' style={bodyStyle}>
      {rows}
    </div>
  )
}

export default TableBody
